window.addEventListener('load', () => {
  const useCredit = $('#id_use_store_credit')
  const amountElem = $('#store-credit-container')
  const amountLeftElem = $('#amount-left')
  const braintree = $('.payment_form.braintree_dropin')
  const braintreeInput = $('#dropin-container')
  const balance = Number(amountElem.data('balance'))
  const total = Number(amountElem.data('order-total'))
  const needsBraintree = () => {
    if (useCredit.prop('checked')) {
      $('#amount_block').removeClass('d-none')
      if (Number(amountElem.val()) >= total) {
        braintree.addClass('d-none')
        braintreeInput.attr('data-skip', 'true')
        amountLeftElem.html('')
        return false
      } else {
        braintree.removeClass('d-none')
        braintreeInput.attr('data-skip', 'false')
        amountLeftElem.html(
          `($${(total - Number(amountElem.val())).toFixed(2)} credit card)`
        )
        return true
      }
    } else {
      braintree.removeClass('d-none')
      braintreeInput.attr('data-skip', 'false')
      $('#amount_block').addClass('d-none')
      amountLeftElem.html('')
      return true
    }
  }
  useCredit.on('change', e => {
    needsBraintree()
  })
  amountElem.on('input', e => {
    needsBraintree()
  })
  const label = $('label[for="id_use_store_credit"]')
  label.html(`Use Store Credit ($${balance} available)`)
  // const form = useCredit.closest('form');
})
